import styled, { keyframes } from "styled-components"

const fadeIn = keyframes`
  from {
    visibility: hidden;
  }

  to {
    visibility: visible;
  }
`

export const Parent = styled.div`
  width: 100%;
  max-width: 34.5rem;
  animation: ${fadeIn} 0.3s ease-in-out;
`
